<script setup lang="ts">
import { computed } from 'vue'
import Chip from '@uiKit/elements/Chip.vue'
import type { ChipSize } from '@uiKit/elements/Chip.vue'
import { propertyStageMetaOf } from '../../constants/propertyLifecycle'

// Status pill for a property's coarse lifecycle stage. Maps `stage` → label +
// semantic color via the single PROPERTY_STAGE_META table.
const props = withDefaults(defineProps<{ stage: string; size?: ChipSize }>(), {
  size: 'medium',
})

const meta = computed(() => propertyStageMetaOf(props.stage))
</script>

<template>
  <Chip :label="meta.label" :color="meta.color" :size="size" />
</template>
